const FIELDWORKER_EARNINGS_URI = '/common/payment-to-fieldworker';
const FIELDWORKER_SHARE = '/fieldworker-share';
const FIELDWORKER_UNPAID = '/un_paid_contractor';
const SET_FIELDWORKER_SHARE = '/booking/contractor_share';

module.exports = {
  /**
   * Get Fieldworker Earnings Via Booking ID,
   * @param bookingId
   * @param itemType
   * @param itemId
   * @param mergedInvoiceId
   * @param bookingNums
   * @returns {Promise<AxiosResponse<any>>}
   */

  getFieldworkersEarnings: function getFieldworkersEarnings(bookingId, itemType, itemId, mergedInvoiceId, bookingNums, viewLocation) {
    return window.axios.get(FIELDWORKER_EARNINGS_URI,
        {
          params:
              {
                booking_id: bookingId,
                item_type: itemType,
                item_id: itemId,
                merged_invoice_id: mergedInvoiceId,
                booking_nums: bookingNums,
                is_api: 1,
                view_location: viewLocation,
              }
        });
  },

    /**
     * Get Fieldworker Share Via Booking ID, fieldworker
     * @param bookingId
     * @param fieldworker
     * @returns {Promise<AxiosResponse<any>>}
     */

    paymentFieldworker: function paymentFieldworker(bookingId, fieldworker) {
    return window.axios.get(FIELDWORKER_SHARE,
        {
          params:
              {
                booking_id: bookingId,
                fieldworker: fieldworker,
              }
        });
  },


    /**
     * Delete Payment for Fieldworker
     * @param fieldworkerPaymentId
     * @returns {Promise<AxiosResponse<any>>}
     */

    unPaidFieldworker: function unPaidFieldworker(fieldworkerPaymentId) {
    return window.axios.get(FIELDWORKER_UNPAID,
        {
          params:
              {
                id: fieldworkerPaymentId,
              }
        });
  },
    saveFieldworkerShareInfo:function saveFieldworkerShareInfo (data , fieldworkerId , bookingId){
        return window.axios.post(SET_FIELDWORKER_SHARE + '/' + bookingId, data , {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },

}